import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export const init = () => {

    const cardSections = gsap.utils.toArray(".section-cards");

    cardSections.forEach(function(cardSection){

        ScrollTrigger.batch(cardSection.querySelectorAll(".card"), {
            interval: 0.1,
            batchMax: 3,
            invalidateOnRefresh: true,
            start: () => 'top bottom',
            end: () => 'bottom top',
            refreshPriority: -1,
            once: true, // nur beim ersten Erscheinen einblenden (kein Ausblenden beim Weiterscrollen)
            onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.15, overwrite: true, ease: "expo", duration: 1.25}),
        });

    });
}

export default init;
